module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ftit"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Kings of England in the"), _c('br'), _vm._v("Later Middle Ages")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Henry III, reigned 1216 to 1272; son of King John and Isabelle of Angoulême; married Eleanor of Provence in 1236")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Edward I, r. 1272 to 1307; son of Henry and Eleanor; married Leonor of Castile in 1254 and Marguerite of France in 1299")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Edward II, r. 1307 to 1327; son of Edward and Leonor; married Isabella of France in 1308")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Edward III, r. 1327 to 1377; son of Edward and Isabella; married Philippa of Hainault in 1328")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Richard II, r. 1377 to 1399; son of Edward and Philippa’s eldest son the Prince of Wales; married Anne of Bohemia in 1382 and Isabelle de Valois in 1396; childless")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Henry IV, r. 1399 to 1413; son of Edward III and Philippa’s son the Duke of Lancaster; married Mary de Bohun in 1394 and Juana of Navarre in 1403")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Henry V, r. 1413 to 1422; son of Henry and Mary; married Katherine de Valois in 1420")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Henry VI, r. 1422 to 1461 and 1470 to 1471; son of Henry and Katherine; married Marguerite of Anjou in 1445")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e2210b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Kings_of_England.vue
// module id = 69
// module chunks = 0